import { Component, HostListener, OnInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { SpeechRecognitionService } from 'src/app/_services/dispo/speech-recognition.service';


@Component({
  selector: 'app-dispo-protokoll',
  templateUrl: './dispo-protokoll.component.html',
  styleUrls: ['./dispo-protokoll.component.css']
})
export class DispoProtokollComponent implements OnInit {
  content: any;
  orderData: any;
  orderForm: any;
  orderTypeList: any;
  statusList: any;
  customerBranchList: any;
  orderList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  isCtrlPressed = false;
  genderList: any;



  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute, 
    private speechRecognitionService: SpeechRecognitionService
  ) { }

  ngOnInit(): void {
     //get current movie data
    
    this.orderService.getCurrentObject().subscribe( data => {
        this.orderData = data;  //store data in variable
        this.orderTypeList = data.orderTypes;
        this.orderList = data.customers;
        this.statusList = data.status;
        this.genderList = data.genders;
        this.customer_id = data.customers.id;
        if(!this.orderData.id) {this.isNew = true};
        this.setForm(data);     //fill form
        this.initCustomerBranches();
        this.prepareChangeListener();
       
      },
      err => { this.content = JSON.parse(err.error).message;}
    );
  }

  prepareChangeListener() {
    this.orderForm.get('customer_id').valueChanges.subscribe(id => {
      this.changeCustomer(id);
    });
   }

   initCustomerBranches() {
      this.changeCustomer(this.orderForm.get('customer_id').value);
   }

   changeCustomer(id) {
    this.customerBranchService.byCustomerId(id).subscribe(
      data => {
        const currentBranchId = this.orderForm.get('customer_branch_id').value;
        const branchExists = data.some(branch => branch.id === currentBranchId);
  
        if (!branchExists) {
          this.orderForm.get('customer_branch_id').setValue(null);
        }
  
        this.customerBranchList = data;
      },
      err => {
        this.orderList = JSON.parse(err.error).message;
      }
    );
  }

  get f(): { [key: string]: AbstractControl } {
    return this.orderForm.controls;
  }

  ngAfterContentInit() {
    
  }
  

  setForm(data) {
    this.orderForm = this.fb.group({
      
      customer_id:                [data.customer_id,Validators.required],
      customer_branch_id:         [data.customer_branch_id,Validators.required],
      order_type_id:              [data.order_type_id,Validators.required],
      order_number:               [data.order_number,Validators.required],
      avis_date:                  [data.avis_date],
      forcast:                    [data.forcast],

      id:                         [data.id],
      company:                    [data.company],
      gender_id:                  [data.gender_id,Validators.required],
      first_name:                 [data.first_name,Validators.required],
      last_name:                  [data.last_name,Validators.required],
      amount_me:                  [data.amount_me],

      street:                     [data.street,Validators.required],
      postal_code:                 [data.postal_code,Validators.required],
      place:                      [data.place,Validators.required],
      country_id:                 [data.country_id],
      level:                      [data.level],

      phone:                      [data.phone],
      mobile:                     [data.mobile],
      fax:                        [data.fax],
      email:                      [data.email],
      email2:                     [data.email],
      email3:                     [data.email],
      status_id:                  [data.status_id],
      account_id:                 [data.account_id],
    });
  }

  archive() {
    Swal.fire({
      title: this.orderData.archive ? 'Soll dieser Auftrag zurückgesetzt werden?' : 'Soll dieser Auftrag archiviert werden?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: this.orderData.archive ? 'Auftrag zurücksetzen' : 'Auftrag archivieren',
      denyButtonText: this.orderData.archive ? 'Auftrag nicht zurücksetzen' : 'Auftrag nicht archivieren',
    }).then((result) => {
      if (result.isConfirmed) {
      this.orderService.archive(this.orderData.id).subscribe( data => {
          if(this.orderData.archive) {
            Swal.fire('Auftrag wurde zurückgesetzt!', '', 'success')
          } else {
            Swal.fire('Auftrag wurde archiviert!', '', 'success')
          }  
      },
        err => { this.content = JSON.parse(err.error).message;}
      );
    } else if (result.isDenied) {
      if(this.orderData.archive) {
        Swal.fire('Auftrag wurde nicht zurückgesetzt!', '', 'success')
      } else {
        Swal.fire('Auftrag wurde nicht archiviert!', '', 'success')
      }  
    }
    })
  }

  submit() {
    this.submitted = true;
    if(this.orderForm.valid) { 
      if(this.isNew) {

        //store
        this.orderService.store(this.orderForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Daten gepeichert!');
            this.router.navigate(['../../'],{ relativeTo: this.route }).then(() => {});
          },
          err => {
            this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');
    
          }
        );
      } else {

        //update
        this.orderService.update(this.orderForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Auftrag "' + data.title + '" erfolgreich geändert', 'Daten gepeichert!');
          },
          err => {
            this.toastr.warning('Ein Fehler ist aufgetreten');

          }
        );
      };
    } else {
      this.toastr.warning('Formular nicht korrekt', 'Bitte prüfen');
    }

  }

  

}
